import React from 'react';

import { IUiMultiSelectProps } from '../model/types';
import cls from '../UiMultiSelect.module.css';

interface IFieldContentProps {
    leftIconSlot?: IUiMultiSelectProps['leftIconSlot'];
    placeholder?: IUiMultiSelectProps['placeholder'];
    isEmptyValues: boolean;
    currentValuesText: string;
}

export const FieldContent = ({
    leftIconSlot,
    placeholder,
    isEmptyValues,
    currentValuesText,
}: IFieldContentProps) => (
    <div className={cls.placeholderWrapper}>
        {leftIconSlot && <span className={cls.leftIcon}>{leftIconSlot}</span>}

        {placeholder && isEmptyValues ? (
            <span className={cls.placeholderText}>{placeholder}</span>
        ) : (
            <span className={cls.selectedSpan} title={currentValuesText}>
                {currentValuesText}
            </span>
        )}
    </div>
);
